<template>
  <div id="paycoupon">
    <div class="top">
      <img :src="couponInfo.logo" alt="" class="logo" />
      <img :src="couponInfo.banner" alt="" class="banner" />
      <div class="title">{{ couponInfo.title }}</div>
      <div class="money">
        <span class="money-1">¥{{ couponInfo.price_pay }}</span>
        <span v-show="couponInfo.price_worth > 0" class="money-2">¥{{ couponInfo.price_worth }}</span>
      </div>
      <div v-if="couponInfo.valid_time_type === 1" class="time">有效期：{{ couponInfo.valid_start_time }}至{{ couponInfo.valid_end_time }}</div>
      <div v-else class="time">领券之日起有效，有效期为{{ couponInfo.valid_days }}天</div>
      <template v-if="from === 'pay_sms'">
        <div @click="handleClick" class="button">打开支付宝查看</div>
      </template>
      <template v-else-if="status === 100 || status === ''">
        <div v-if="couponInfo.status === 0" class="button gray">未激活</div>
        <div v-else-if="couponInfo.status === 1" class="button gray">已激活</div>
        <div v-else-if="couponInfo.status === 2" class="button gray">已下架</div>
        <div v-else-if="couponInfo.status === 3" class="button gray">未到派发时间</div>
        <div v-else-if="couponInfo.status === 4" @click="handleClick" class="button">
          <template v-if="status === 100">立即购买</template>
          <template v-else-if="status === ''">打开支付宝付款</template>
        </div>
        <div v-else-if="couponInfo.status === 5" class="button gray">已下架</div>
        <div v-else-if="couponInfo.status === 6" class="button gray">已下架</div>
      </template>
      <div v-else-if="status === 101" class="button">领取到卡包</div>
      <div v-else-if="status === 102" @click="openCouponURL" class="button">购买成功，立即使用</div>
      <div v-else-if="status === 103" class="button gray">已使用</div>
      <div v-else-if="status === 104" class="button gray">已过期</div>
      <div v-else-if="status === 105" class="button gray">已失效</div>
      <div class="tips" v-if="couponInfo.business_type === 1">7天内自动退款</div>
    </div>
    <img src="../img/line.png" alt="" class="line" />
    <div class="bottom">
      <table>
        <tr v-show="couponInfo.cars && couponInfo.cars.length > 0">
          <td>适用车系</td>
          <td class="cars">
            <div v-for="(item, index) in couponInfo.cars" :key="index">{{ item }}</div>
          </td>
        </tr>
        <tr v-show="couponInfo.welfare">
          <td>到店福利</td>
          <td>{{ couponInfo.welfare }}</td>
        </tr>
        <tr v-show="couponInfo.notice">
          <td>使用须知</td>
          <td>{{ couponInfo.notice }}</td>
        </tr>
        <tr v-show="couponInfo.store">
          <td>适用门店</td>
          <td>{{ couponInfo.store }}</td>
        </tr>
        <tr>
          <td></td>
          <td>本服务由{{ couponInfo.provider }}提供。客服热线：020-38895471，请在工作日09:00-17:00联系。</td>
        </tr>
      </table>
    </div>
    <img src="../img/logo.png" alt="" class="pcauto-logo" />
  </div>
</template>

<script>
import { checkAuth } from 'common/js/api'
import { isIOS, isAlipay, getQueryString, getQueryStringBase } from 'common/js/util'
import Share from 'common/js/share'

export default {
  name: 'paycoupon',
  data() {
    return {
      uid: '',
      status: '',
      couponURL: '',
      couponInfo: {},
      tradeNO: '',
      count: 0
    }
  },
  created() {
    if (isAlipay) {
      this.checkAuth()
    } else {
      this.getCouponInfo()
    }
  },
  computed: {
    from() {
      return !isAlipay && getQueryString('from')
    }
  },
  methods: {
    async checkAuth() {
      const callback = getQueryStringBase('callback')
      const url = window.location.href.replace(callback, encodeURIComponent(callback))
      const res = await checkAuth.call(this, url)
      if (res.code === 0) {
        this.uid = res.data.uid
        this.getCouponInfo()
      } else if (res.code === 9) {
        window.location.href = res.data.jump_url
      } else {
        this.$toast(res.msg)
      }
    },
    async getCouponInfo() {
      const res = await this.$get({
        baseURL: this.$baseURL.merchant,
        url: '/AliCoupon/showCoupon',
        params: {
          coupon_id: getQueryString('id')
        }
      })
      if (res.code === 0) {
        this.couponInfo = res.data
        this.uid && this.getOrderStatus()
        // 设置title和分享
        document.title = this.couponInfo.title
        const shareData = {
          title: this.couponInfo.title,
          desc: `仅售${this.couponInfo.price_pay}元，数量有限，先到先得`,
          link: 'https://cat.pangku.com/dist/coupon/paycoupon.html',
          imgUrl: this.couponInfo.logo
        }
        new Share(shareData)
      } else {
        this.$toast(res.msg)
      }
    },
    async getOrderStatus() {
      const res = await this.$get({
        baseURL: this.$baseURL.api,
        url: '/v1/pay/coupon/pay_info',
        params: {
          coupon_id: getQueryString('id'),
          uid: this.uid
        }
      })
      if (res.code === 0) {
        this.status = res.data.status
        this.couponURL = res.data.coupon_url
        // 判断用户是否执行callback
        if (this.status === 102 && !this.$storejs.get(`${getQueryString('id')}PaycouponCallback`)) {
          this.jumpCallback(res.data.sign)
        }
      } else {
        this.$toast(res.msg)
      }
    },
    handleClick() {
      if (this.uid) {
        this.createTradeNO()
      } else {
        this.checkAuth()
      }
    },
    // https://cat.pangku.com/dist/coupon/paycoupon.html?id=21549&channel=OTHER_unknown&model_id=&serial_id=&scanfrom=coupon&city_id=&type_nid=PAY
    async createTradeNO() {
      const res = await this.$post({
        baseURL: this.$baseURL.api,
        url: '/v1/pay/coupon/create_trade_no',
        data: {
          coupon_id: getQueryString('id'),
          ali_openid: this.uid,
          extras_param: encodeURIComponent(`channel=${getQueryString('channel')}&serial_id=${getQueryString('serial_id')}&model_id=${getQueryString('model_id')}&city_id=${getQueryString('city_id')}`)
        }
      })
      if (res.code === 0) {
        this.tradeNO = res.data.trade_no
        ap.tradePay({
          tradeNO: this.tradeNO
        }).then(res => {
          const resultCode = res.resultCode
          if (resultCode === '9000') {
            if (isIOS) {
              ap.onResume(() => {
                ap.offResume()
                this.isSuccess()
              })
            } else {
              this.isSuccess()
            }
          }
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async isSuccess() {
      const res = await this.$get({
        baseURL: this.$baseURL.api,
        url: '/v1/pay/coupon/order_no_status',
        params: {
          trade_no: this.tradeNO
        }
      })
      if (res.code === 0) {
        if (res.data.order_status_flag === 'success_and_coupon') {
          this.getOrderStatus()
        } else {
          if (this.count < 5) {
            setTimeout(() => {
              this.count++
              this.isSuccess()
            }, 1000)
          } else {
            this.$toast('操作失败，请重新再试')
          }
        }
      } else {
        this.$toast(res.msg)
      }
    },
    jumpCallback(sign) {
      const callback = getQueryString('callback')
      if (callback) {
        const params = `success=true&coupon_id=${getQueryString('id')}&coupon_title=${this.couponInfo.title}&uid=${this.uid}&sign=${sign}`
        const jumpURL = `${callback}${callback.indexOf('?') > -1 ? '&' : '?'}${params}`
        console.log(jumpURL)
        this.$storejs.set(`${getQueryString('id')}PaycouponCallback`, true)
        // 用于活动自动关闭详情页
        if (getQueryString('auto_close')) {
          ap.onResume(() => {
            ap.popWindow()
          })
        }
        ap.pushWindow(jumpURL)
      }
    },
    openCouponURL() {
      ap.pushWindow(this.couponURL)
    }
  }
}
</script>

<style lang="scss">
body {
  background: #f0eff5;
}
#paycoupon {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 93%;
  background: #ffffff;
  margin-top: 36px * 2;
  border-top-left-radius: 4px * 2;
  border-top-right-radius: 4px * 2;
}
.logo {
  width: 46px * 2;
  height: 46px * 2;
  border-radius: 50%;
  margin-top: -25px * 2;
  background: #ffffff;
  border: 1px solid #eeeeee;
}
.banner {
  width: 90%;
  margin-top: 10px * 2;
}
.title {
  width: 90%;
  font-size: 18px * 2;
  text-align: left;
  line-height: 1.4;
  margin-top: 9px * 2;
  margin-bottom: 4px * 2;
}
.money {
  width: 88%;
}
.money-1 {
  color: #fd8f26;
  font-size: 24px * 2;
}
.money-2 {
  color: #999999;
  text-decoration: line-through;
  margin-left: 6px * 2;
}
.time {
  width: 88%;
  color: #666666;
  margin-top: 4px * 2;
}
.button {
  width: 64%;
  height: 42px * 2;
  line-height: 42px * 2;
  text-align: center;
  background: #00a0e9;
  color: #ffffff;
  font-size: 16px * 2;
  border-radius: 24px * 2;
  margin-top: 20px * 2;
}
.button.gray {
  background: #999999;
}
.line {
  width: 93%;
}
.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 93%;
  background: #ffffff;
  border-bottom-right-radius: 4px * 2;
  border-bottom-left-radius: 4px * 2;
  padding-top: 10px * 2;
  padding-bottom: 10px * 2;
}
.tips {
  color: #00a0e9;
  margin-top: 8px * 2;
  margin-bottom: 14px * 2;
}
table {
  width: 90%;
}
td {
  min-width: 64px * 2;
  padding: 8px * 2 0;
  vertical-align: top;
  white-space: pre-line;
}
.cars {
  white-space: normal;
}
tr td:last-of-type {
  color: #666666;
  border-bottom: 1px solid #f4f4f4;
}
table tr:last-of-type td:last-of-type {
  border-color: transparent;
}
.pcauto-logo {
  width: 206px * 1.5;
  margin-top: 14px * 2;
  margin-bottom: 20px * 2;
}
</style>
